<template>
  <!--
    作者：gmshop
    时间：2020-06-04
    描述：插件中心-积分商城-商品列表
  -->
  <div class="user" v-loading="loading">
    <div class="common-form d-s-c">
      <span>商品管理</span>
      <div class="ml20"><el-button type="primary" size="small" icon="el-icon-plus" @click="changeProduct" v-auth="'/ministore/product/add'">选择商品</el-button></div>
    </div>
    <div class="product-content point-list">
      <div class="table-wrap">
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部商品" name="all"></el-tab-pane>
          <el-tab-pane label="未审核" name="nocheck"></el-tab-pane>
          <el-tab-pane label="审核中" name="check"></el-tab-pane>
          <el-tab-pane label="审核失败" name="error"></el-tab-pane>
          <el-tab-pane label="审核成功" name="success"></el-tab-pane>
        </el-tabs> -->
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="product_name" label="商品名称" width="360">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic" style="width: 40px; height: 40px;"><img v-img-url="scope.row.product.image[0].file_path" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product.product_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span v-if="scope.row.product.spec_type == 10">单规格</span>
              <span v-if="scope.row.product.spec_type == 20">多规格</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="活动库存"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span  @click="editStatus(scope.row.ministore_product_id, scope.row.status)" v-if="scope.row.status == 10" class="green">上架</span>
              <span  @click="editStatus(scope.row.ministore_product_id, scope.row.status)" v-if="scope.row.status == 20" class="gray">下架</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-auth="'/ministore/product/edit'" @click="editClick(scope.row.ministore_product_id)" type="text" size="small">编辑</el-button>
              <el-button v-if="scope.row.status == 20" v-auth="'/ministore/product/listing'" @click="listingClick(scope.row.ministore_product_id)" type="text" size="small">上架</el-button>
              <el-button v-if="scope.row.status == 10" v-auth="'/ministore/product/delisting'" @click="delistingClick(scope.row.ministore_product_id)" type="text" size="small">下架</el-button>
              <el-button v-if="scope.row.wx_edit_status == 1 || scope.row.wx_edit_status == 2" v-auth="'/ministore/product/delaudit'" @click="delauditClick(scope.row.ministore_product_id)" type="text" size="small">撤回审核</el-button>
              <el-button v-auth="'/ministore/product/delete'" @click="deleteClick(scope.row.ministore_product_id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="exclude_ids" :islist="false" @closeDialog="closeProductFunc"></Product>
  </div>
</template>
<script>
import MinistoreApi from '@/api/ministore.js';
import Product from '@/components/product/Product.vue';
export default {
  components: {
    /*选择商品*/
    Product
  },
  data() {
    return {
      /*表格数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否加载完成*/
      loading: true,
      /*是否修改*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*是否打开选择商品*/
      isproduct: false,
      /*已有的id*/
      exclude_ids: [],
      activeName: 'all'
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    editStatus(ministore_product_id, status) {
      let self = this;
      if(status==20){
         self.$confirm('确认改变商品状态吗?', '提示', {
            type: 'warning'
          })
          .then(() => {
            MinistoreApi.listingProduct({
              id: ministore_product_id,
            }).then(data => {
              
            });
          });
      }else{
          self.$confirm('确认改变商品状态吗?', '提示', {
            type: 'warning'
          })
          .then(() => {
            MinistoreApi.delistingProduct({
              id: ministore_product_id,
            }).then(data => {
              
            });
          });
      }
     
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getTableList();
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      MinistoreApi.productList(Params, true)
        .then(res => {
          self.exclude_ids = res.data.exclude_ids;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },

    /*关闭商品选择*/
    closeProductFunc(e) {
      this.isproduct = false;
      if (e.type == 'success') {
        this.addClick(e.params.product_id);
      }
    },

    /*添加商品*/
    addClick(product_id) {
      this.$router.push('/ministore/product/add?product_id=' + product_id);
    },

    /*编辑商品*/
    editClick(e) {
      let self = this;
      this.$router.push({
        path: '/ministore/product/edit',
        query: {
          ministore_product_id: e
        }
      });
    },

    /* 查询*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      self.getTableList();
    },

    delauditClick(e){
      let self = this;
      self
        .$confirm('确定要撤回商品审核吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          MinistoreApi.delauditProduct(
            {
              id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    listingClick(e){
      let self = this;
      self
        .$confirm('确定要上架商品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          MinistoreApi.listingProduct(
            {
              id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    delistingClick(e){
      let self = this;
      self
        .$confirm('确定要下架商品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          MinistoreApi.delistingProduct(
            {
              id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    /*删除用户*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          MinistoreApi.deleteProduct(
            {
              id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }

  }
};
</script>

<style>
.point-list .el-input-number--mini {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/ministore/product/index.vue